import Vue from 'Vue';

/* global _as_rest */
/* eslint camelcase: 0 */

export const alertAndConsole = message => {
  // eslint-disable-next-line yoda
  if (typeof message !== 'string') {
    message = message.join('\n');
  }

  // eslint-disable-next-line no-console
  console.log(message);
  // eslint-disable-next-line no-alert
  // alert(message);
};

export const getElement = selector => document.querySelector(selector);

export const elementExists = selector => null !== getElement(selector);

export const getAttribute = (selector, attribute, _default = false) => {
  let element = getElement(selector);
  let isData = /^data-/.test(attribute);

  if (null === element) {
    return _default;
  }

  let value = element.getAttribute(attribute);

  if (isData) {
    let json = element.dataset[attribute.replace(/^data-/, '')];

    try {
      value = JSON.parse(json);
    } catch (e) {
      value = json;
    }
  }

  if (value) {
    return value;
  }

  return _default;
};

export const setAttribute = (selector, attribute, value) => {
  let element = getElement(selector);

  if (null === element) {
    return false;
  }

  element.setAttribute(attribute, value);

  return true;
};

export const removeAllVuePreloadHiddenClasses = selector => {
  const parent = document.querySelector(selector);

  if (null === parent) {
    return;
  }

  const className = 'vue-preload-hidden';
  const elements = parent.querySelectorAll(`.${className}`);

  for (let i = 0; i < elements.length; ++i) {
    elements[i].classList.remove(className);
  }
};

export const removeAllVuePostloadHiddenElements = selector => {
  const parent = document.querySelector(selector);

  if (null === parent) {
    return;
  }

  const className = 'vue-postload-hidden';
  const elements = parent.querySelectorAll(`.${className}`);

  for (let i = 0; i < elements.length; ++i) {
    elements[i].parentNode.removeChild(elements[i]);
  }
};

window.$asEventBus = window.$asEventBus || new Vue();
export const $eventBus = window.$asEventBus;
